var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadOffline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download-core-small",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M36 70.2008C54.8882 70.2008 70.2001 54.8889 70.2001 36.0008C70.2001 17.1126 54.8882 1.80078 36 1.80078C17.1119 1.80078 1.80005 17.1126 1.80005 36.0008C1.80005 54.8889 17.1119 70.2008 36 70.2008Z",
    fill: "url(\"#paint0_radial_5179_7940\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.4,
    d: "M64.7658 36.195C65.5206 51.5916 53.7908 63.5824 38.5668 62.977C23.3428 62.3722 10.3893 49.4 9.63446 34.0034C8.87954 18.6068 20.6091 6.61594 35.8331 7.22116C51.0571 7.82638 64.0104 20.7984 64.7658 36.195Z",
    fill: "url(\"#paint1_radial_5179_7940\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M62.3657 37.9958C63.1205 53.3924 51.3908 65.3832 36.1668 64.7778C20.9428 64.173 7.9893 51.2008 7.23444 35.8041C6.47952 20.4075 18.2091 8.41672 33.4331 9.02194C48.6571 9.62716 61.6103 22.5992 62.3657 37.9958Z",
    fill: "url(\"#paint2_radial_5179_7940\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.5,
    d: "M64.7658 36.195C65.5206 51.5916 53.7908 63.5824 38.5668 62.977C23.3428 62.3722 10.3893 49.4 9.63446 34.0034C8.87954 18.6068 20.6091 6.61594 35.8331 7.22116C51.0571 7.82638 64.0104 20.7984 64.7658 36.195Z",
    fill: "url(\"#paint3_radial_5179_7940\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.6,
    d: "M36.9 60.6C48.6636 60.6 58.2 51.0637 58.2 39.3C58.2 27.5363 48.6636 18 36.9 18C25.1363 18 15.6 27.5363 15.6 39.3C15.6 51.0637 25.1363 60.6 36.9 60.6Z",
    fill: "url(\"#paint4_radial_5179_7940\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0849 42.2727L46.3387 35.76L48.8945 38.5142L38.9118 47.477L37.8466 48.4333L36.6071 47.477L24.9899 38.5142L27.0434 35.76L35.4849 42.2727L33.6 21.6016H37.2L39.0849 42.2727Z",
    fill: "url(\"#paint5_radial_5179_7940\")"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6566 34.9618C61.7832 35.3893 62.391 35.3233 62.3694 34.878C61.6962 21.1369 50.1509 9.55975 36.5817 9.01957C34.4606 8.93515 32.4155 9.12541 30.4772 9.55909C30.0745 9.64915 30.1575 10.2082 30.5697 10.2246C45.0094 10.7979 57.6246 21.2971 61.6566 34.9618Z",
    fill: "url(\"#paint6_radial_5179_7940\")"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0001 36.1837) rotate(-90) scale(34.3829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782019,
    stopColor: "#982DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906819,
    stopColor: "#B038DC",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9937 20.0992) rotate(135) scale(49.9836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFBDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F89DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7999 19.6937) rotate(135) scale(53.1037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FF787F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F45FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44AF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9937 20.0992) rotate(135) scale(49.9836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFBDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F89DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9 39.3) scale(21.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2 32.1016) rotate(39.5226) scale(15.5567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2406,
    stopColor: "#E50914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792A95"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7 21.3) rotate(-180) scale(30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0001 36.1837) rotate(-90) scale(34.3829)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.782019,
    stopColor: "#982DBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906819,
    stopColor: "#B038DC",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9937 20.0992) rotate(135) scale(49.9836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFBDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F89DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7999 19.6937) rotate(135) scale(53.1037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA984"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FF787F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F45FA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C44AF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9937 20.0992) rotate(135) scale(49.9836)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.333333,
    stopColor: "#FFBDC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.666667,
    stopColor: "#F89DC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4A1FA"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9 39.3) scale(21.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2 32.1016) rotate(39.5226) scale(15.5567)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7744"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2406,
    stopColor: "#E50914"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792A95"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_5179_7940",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7 21.3) rotate(-180) scale(30)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadOffline);
export default __webpack_public_path__ + "static/media/download-offline.108dae4161a41636f1d37fde574220e2.svg";
export { ForwardRef as ReactComponent };